import GerepAPI from './GerepAPI'

export default class SuggestService {

	static getPays() {
		return GerepAPI.get('/suggest/pays')
	}
}
